import { lazy } from 'react';
import { APP_SECTIONS_PATHS, RESOURCES_FOLDER_ROUTES, COLLECTION_ROUTES } from 'constants/routes';

// Views
import CalendarView from 'views/CalendarView';
import CenterView from 'components/settings/center/CenterView';
import { ClassroomDetails, TeacherProfile } from 'components/settings';
import { EditMember } from 'components/settings/Staff/Manage/EditMember/EditMember';

const DapView = lazy(() => import('views/DapView'));
const MyPlansView = lazy(() => import('views/MyPlansView'));
const ActivityView = lazy(() => import('views/ActivityView/components/ActivityViewComponent/ActivityViewComponent'));
const ResourcesView = lazy(() => import('views/resources/ResourcesView/ResourcesView'));
const ResourcesBySubcategoryView = lazy(() => import('views/resources/ResourcesBySubcategoryView'));
const SubcategoriesView = lazy(() => import('views/resources/SubcategoriesView'));
const PortfolioView = lazy(() => import('views/PortfolioView'));
const SettingsView = lazy(() => import('views/SettingsView/SettingsView'));
const AddStudentView = lazy(() => import('views/AddStudentView'));
const StudentProfileView = lazy(() => import('views/StudentProfileView/StudentProfileView'));
const CatalogView = lazy(() => import('views/CatalogView/CatalogView'));
const MessagesView = lazy(() => import('views/Messages/MessagesView'));
const UploadActivityView = lazy(() => import('views/UploadActivityView'));
const PremiumProcessView = lazy(() => import('components/premiumProcess/PremiumProcessFlow'));
const UserProfileView = lazy(() => import('../views/UserProfileView/UserProfileView'));
const SandboxView = lazy(() => import('views/SandboxView'));
const NotFoundView = lazy(() => import('views/NotFoundView'));
const UnderConstructionView = lazy(() => import('views/UnderConstructionView'));
const Subcollections = lazy(() => import('views/Subcollections'));
const SubcollectionsActivity = lazy(() => import('views/SubcollectionsActivity'));
const StudentArticleView = lazy(() => import('views/StudentArticleView'));
// const StudentActivityView = lazy(() => import('views/StudentActivityView'));

export interface RouteItemProps {
  exact?: boolean;
  path?: string;
  component: any;
  layout?: any;
  meta: any;
}

export const noMenuRoutes: RouteItemProps[] = [
  {
    path: APP_SECTIONS_PATHS.PREMIUM_PROCESS,
    component: PremiumProcessView,
    exact: false,
    meta: {},
  },
  {
    path: APP_SECTIONS_PATHS.SANDBOX,
    component: SandboxView,
    exact: false,
    meta: {},
  },
];

export const menuRoutes: RouteItemProps[] = [
  {
    path: APP_SECTIONS_PATHS.ROOT,
    component: DapView,
    exact: true,
    meta: {},
  },
  {
    path: APP_SECTIONS_PATHS.DAP,
    component: DapView,
    exact: false,
    meta: {},
  },
  {
    path: APP_SECTIONS_PATHS.MY_PLANS,
    component: MyPlansView,
    exact: false,
    meta: {},
  },
  {
    path: APP_SECTIONS_PATHS.ADD_STUDENTS,
    component: AddStudentView,
    exact: false,
    meta: {},
  },
  {
    path: APP_SECTIONS_PATHS.CATALOG,
    component: CatalogView,
    exact: true,
    meta: {},
  },
  {
    path: APP_SECTIONS_PATHS.PROGRESS,
    component: UnderConstructionView,
    exact: false,
    meta: {},
  },
  {
    path: APP_SECTIONS_PATHS.MILESTONES,
    component: UnderConstructionView,
    exact: false,
    meta: {},
  },
  {
    path: APP_SECTIONS_PATHS.SETTINGS,
    component: SettingsView,
    exact: false,
    meta: {},
  },
  {
    meta: {},
    exact: true,
    path: APP_SECTIONS_PATHS.CENTER_SETTINGS,
    component: CenterView,
  },
  {
    meta: {},
    exact: true,
    path: APP_SECTIONS_PATHS.SETTINGS_STAFF,
    component: EditMember,
  },
  {
    path: APP_SECTIONS_PATHS.USER_PROFILE,
    component: UserProfileView,
    exact: false,
    meta: {},
  },
  {
    path: APP_SECTIONS_PATHS.ACTIVITY,
    component: ActivityView,
    exact: false,
    meta: {},
  },
  {
    path: APP_SECTIONS_PATHS.UPLOAD_ACTIVITY,
    component: UploadActivityView,
    exact: false,
    meta: {},
  },
  {
    path: APP_SECTIONS_PATHS.RESOURCES,
    component: ResourcesView,
    exact: true,
    meta: {},
  },
  {
    path: APP_SECTIONS_PATHS.PORTFOLIO,
    component: PortfolioView,
    exact: true,
    meta: {},
  },
  {
    path: RESOURCES_FOLDER_ROUTES.SUBCATEGORY,
    component: SubcategoriesView,
    exact: true,
    meta: {},
  },
  {
    path: RESOURCES_FOLDER_ROUTES.RESOURCES,
    exact: true,
    component: ResourcesBySubcategoryView,
    meta: {},
  },
  {
    path: APP_SECTIONS_PATHS.MESSAGES,
    component: MessagesView,
    exact: false,
    meta: {},
  },
  {
    path: APP_SECTIONS_PATHS.CALENDAR,
    component: CalendarView,
    exact: false,
    meta: {},
  },
  {
    path: APP_SECTIONS_PATHS.STUDENTS_PROFILE,
    component: StudentProfileView,
    exact: false,
    meta: {},
  },
  {
    meta: {},
    exact: false,
    path: APP_SECTIONS_PATHS.TEACHER_PROFILE,
    component: TeacherProfile,
  },
  {
    meta: {},
    exact: false,
    path: APP_SECTIONS_PATHS.CLASSROOM_DETAILS,
    component: ClassroomDetails,
  },
  {
    path: COLLECTION_ROUTES.SUBCOLLECTIONS,
    component: Subcollections,
    exact: true,
    meta: {},
  },
  {
    path: COLLECTION_ROUTES.SUBCOLLECTIONS_ACTIVITY,
    component: SubcollectionsActivity,
    exact: true,
    meta: {},
  },
  {
    path: APP_SECTIONS_PATHS.STUDENT_ARTICLE,
    component: StudentArticleView,
    exact: true,
    meta: {},
  },
  {
    path: '',
    component: NotFoundView,
    meta: {},
  },
];

export const allRoutes: RouteItemProps[] = [...menuRoutes, ...noMenuRoutes];
